import { Component, EventEmitter, Output } from '@angular/core';
import { Constants } from '@base/src/app/models/constants';
import { DialogEvent } from '@base/src/app/models/dialog-event.model';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRIcon } from '@base/src/app/models/qr-icon.model';
@Component({
  selector: 'app-rendition-draft-created',
  templateUrl: './rendition-draft-created.component.html',
  styleUrls: ['./rendition-draft-created.component.scss'],
})
export class RenditionDraftCreatedComponent {
  @Output() change: EventEmitter<any> = new EventEmitter<any>();
  @Output() dialogChange: EventEmitter<DialogEvent> =
    new EventEmitter<DialogEvent>();
  value: string | undefined;

  buttonGoPanel: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir al listado',
  };

  buttonPrint: QRButton = {
    hierarchy: QRButton.HIERARCHY_3,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Ir a borradores',
  };

  readonly ICON_DONE = Constants.ICONS.CHECK_2;
  readonly ICON_COLOR_WHITE = QRIcon.COLOR_WHITE;

  onAction(type: number) {
    location.href = type == 1 ? 'renditions' : 'renditions/drafts';
  }
}
